// @flow
import asessmentSchema from "src/schemas/assessmentAnswerSchema";
import { relationshipReducer } from "src/utils/reducerUtils";

export const assessmentAnswerRelationships = relationshipReducer({
  name: "assessmentAnswers",
  relationshipSchemas: asessmentSchema.relationshipSchemas
});
